module.exports = __webpack_public_path__ + "img/blockAB34.dec41e87.svg";